module.exports = __webpack_public_path__ + "img/bg_product.3c05ddf8.png";